<template lang="pug">
  .welcome-to-rcd-modal.clearfix
    .xs-12.text-center(v-if="showRecentWelcome")
      p.color-purple.semi-bold.xs-f-xxxlarge.lg-f-grande.max-at-tweak Welcome {{cdata.firstName ? cdata.firstName : 'Beautiful'}}
      p.welcome-text.xs-f-small.max-at-tweak We're excited to introduce you to your personalized Madison Reed experience where you can easily manage your subscriptions, access order history, and find new products to love.
      button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type="button" @click="hideModal()" data-mr-ass="check-it-out") check it out

    .xs-12.text-center(v-else)
      p.color-purple.semi-bold.xs-f-xxxlarge.lg-f-grande.max-at-tweak
        | Welcome Back,
        br
        |  {{cdata.firstName ? cdata.firstName : 'Beautiful'}}
      p.welcome-text.xs-f-small.max-at-tweak We love makeovers around here, so we're excited to introduce a new look &amp; feel for your Madison Reed experience. Now it's even easier to manage your subscriptions, access order history, and find new products to love.
      button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type="button" @click="hideModal") check it out

</template>

<script>
  import { mapState, mapActions } from "vuex";

  export default {
    name: 'WelcomeToRCDModal',

    computed: {
      ...mapState('customer', ['cdata']),

      showRecentWelcome() {
        if (!this.cdata || !this.cdata.lastPurchaseDate) {
          return true;
        }
        var now = + new Date();
        var mostRecentPurchase = + new Date(this.cdata.lastPurchaseDate);
        var twentyFourHours = 1000 * 60 * 60 * 24;

        if (now - mostRecentPurchase > twentyFourHours) {
          return false;
        }

        return true;
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal'])
    },

    mounted() {
      this.$root.persistCustomerAnswers({ welcomed_to_rcd: true });
    }
  }
</script>

<style lang="stylus">
  .welcome-to-rcd-modal
    padding 1em 5%

    .welcome-text
      padding 1.5em 0

    @media mq-desktop-plus
      padding 1em 15%

</style>
